module.exports = __webpack_public_path__ + "files/09a84a2a41f19a52a3463b0d19b0bb36.png";